export default "__VITE_ASSET__ByYilt6g__"